<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
@import url("https://api.fontshare.com/css?f[]=supreme@100,101,200,201,300,301,400,401,500,501,700,701,800,801&display=swap");
@import url("https://api.fontshare.com/css?f[]=chillax@200,300,400,500,600,700&display=swap");



@font-face {
  font-family: 'BrownSugar';
  src:  url('./assets/font/BrownSugar.ttf'),
  url('./assets/font/BrownSugar.otf')
}



#app {
  font-family: 'Chillax', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;

}
html,body
{
  width: 100%;
  height: 100%;

}
</style>



// WEBPACK FOOTER //
// src/App.vue